import Vue from 'vue';

export default {
  initializeApp(state, payload) {
    Vue.set(state, 'visitorId', payload.visitorId || 1);
    Vue.set(state, 'lang', payload.lang);
  },
  loadCmsData(state) {
    Vue.set(state, 'cmsData', null);
    Vue.set(state, 'dataLoadError', null);
    Vue.set(state, 'showLoadindicator', true);
    Vue.set(state, 'lastHttpAction', 'loadCmsData');
  },
  loadCmsDataSuccess(state, payload) {
    Vue.set(state, 'cmsData', payload);
    Vue.set(state, 'showLoadindicator', false);
    Vue.set(state, 'lastHttpAction', null);
  },
  loadCmsDataFailed(state, payload) {
    Vue.set(state, 'dataLoadError', payload);
    Vue.set(state, 'showLoadindicator', false);
  },
  updateCurrentStep(state, payload) {
    if (typeof payload == 'undefined') {
      payload = state.currentStep + 1;
    }
    Vue.set(state, 'currentStep', payload);
  },
  updateScreenState(state, payload) {
    Vue.set(state, 'screenState', payload);
  },
  updateStartTimestamp(state, payload) {
    Vue.set(state, 'stationStartTimestamp', payload);
  },
  updateEndTimestamp(state, payload) {
    Vue.set(state, 'stationEndTimestamp', payload);
  },
  updateClickCounter(state) {
    Vue.set(state, 'clickCount', state.clickCount + 1);
  },
  updateCorrectAnsweredStats(state) {
    Vue.set(state, 'correctAnswered', state.correctAnswered + 1);
  },
  updateWrongAnsweredStats(state) {
    Vue.set(state, 'wrongAnswered', state.wrongAnswered + 1);
  },
  sendStatistics(state) {
    Vue.set(state, 'showLoadindicator', true);
    Vue.set(state, 'lastHttpAction', 'sendStatistics');
  },
  sendStatisticsSuccess(state, payload) {
    Vue.set(state, 'sendStatisticsSuccess', payload);
    Vue.set(state, 'showLoadindicator', false);
    Vue.set(state, 'lastHttpAction', null);
    window.postMessage('end');
  },
  sendStatisticsFailed(state, payload) {
    Vue.set(state, 'dataLoadError', payload);
    Vue.set(state, 'showLoadindicator', false);
  },

};